export default {
  //独有的命名空间
  state: {
    userInfo: (localStorage.getItem("userInfo") && JSON.parse(localStorage.getItem("userInfo"))) || null,
    isLogin: false,
    userMenus: {}
  },
  mutations: {
    setUserInfo(state, uInfo) {
      state.userInfo = uInfo
    }
  },

}